<template>
    <div id="kooptext">
        <h2>Te koop</h2>

        <p>Incidenteel verkoop ik mijn dubbele ansichtkaarten via Marktplaats. Ook kaarten die niet in mijn verzameling
            passen verkoop ik op deze wijze.</p>

        <p>Aangezien ik verzamelaar ben en geen handelaar, is er geen gegarandeerd aanbod. Het huidige aanbod vindt u
            <a href="https://www.marktplaats.nl/verkopers/38059259.html">hier</a>.</p>

    </div>
</template>

<script>
    export default {
        name: "KoopText"
    }
</script>

<style scoped lang="scss">
    #kooptext {
        p {
            font-size: 1.5em;
            text-align: start;
            @media screen and (max-device-width: 1200px) {
                font-size: 1.2em;
            }
        }

        @media not all and (max-device-width: 1200px) {
            margin: 30px 20em 0 23em;
        }
    }
</style>